<template>

    <div class=" ">



        <vue-pdf-embed :source="pdfSource" @rendered="pdfReady" />

    </div>

</template>

<script>

    import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js';



    export default {

       name: 'ZetosPDFView',
       components: { VuePdfEmbed },


       computed: {

            pdfSource(){
                return this.getConf('secondaryEndpoint') + '/application/agreement';
               // return 'static/sample.pdf';
            }
       },


       methods: {


        pdfReady() {

        }


       },



       mounted(){



            // scroll to top with .5s delay
            this.pageTop();

       }




    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/ZetosPDFView.vue